import { Palette } from '@mui/material';
import { FontSize } from '@store/types/UserStoreSlice.type';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const MuiIconButton = ({ palette, fontSize }: { palette: Palette; fontSize: FontSize }) => ({
  styleOverrides: {
    sizeSmall: {
      width: '28px',
      height: '28px',
      padding: '6px',
    },
    sizeMedium: {
      width: '36px',
      height: '36px',
      padding: '8px',
    },
  },
});
